import { Button, Form, Notification, Section } from 'react-bulma-components';
import { gql, useMutation } from '@apollo/client';

import PageTitle from '../components/pagetitle';
import React from 'react';
import { useForm } from '../hooks/formState';

const { Control, Field, Input, Label, Textarea } = Form;

const SUBMIT_CONTACT_MESSAGE = gql`
  mutation SubmitContactMessage($subject: String!, $message: String!, $honeypot: String) {
    submitContactMessage(subject: $subject, message: $message, honeypot: $honeypot)
  }
`;

const ContactPage = () => {
  const [submitContactMessage, { loading, error, data }] = useMutation(SUBMIT_CONTACT_MESSAGE);
  const { values, handleChange, handleSubmit, setValues } = useForm((formValues) => submitForm(formValues), {
    subject: '',
    message: '',
    website: '', // Honeypot - dolt för riktiga besökare, se fältet nedan
  });
  const submitForm = async ({ subject, message, website }) => {
    await submitContactMessage({ variables: { subject, message, honeypot: website } }).catch(() => {});
    setValues({ subject: '', message: '', website: '' });
  }
  return(
    <>
      <PageTitle
        name="Contact"
        description="Let's keep in touch!"></PageTitle>
       <Section>
        {data?.submitContactMessage && (
          <Notification color="success">Thanks! Your message has been sent.</Notification>
        )}
        {error && (
          <Notification color="danger">
            {error.graphQLErrors?.some(e => e.extensions?.code === 'TOO_MANY_REQUESTS')
              ? "You've sent too many messages recently - please try again later."
              : 'Something went wrong, please try again.'}
          </Notification>
        )}
        <form onSubmit={handleSubmit}>
        {/* Honeypot - osynligt för riktiga besökare (och skärmläsare), men botar som
            fyller i alla formulärfält trillar ofta på det. */}
        <div style={{ position: 'absolute', left: '-9999px', width: 1, height: 1, overflow: 'hidden' }} aria-hidden="true">
          <Input
            type="text"
            name="website"
            tabIndex={-1}
            autoComplete="off"
            value={values.website}
            onChange={handleChange}
          />
        </div>
        <Field>
          <Label>Subject</Label>
          <Control>
            <Input onChange={handleChange} name="subject" type="text" placeholder="Subject" value={values.subject} />
          </Control>
        </Field>
        <Field>
          <Label>Message</Label>
          <Control>
            <Textarea name={'message'} placeholder="Textarea" value={values.message} onChange={handleChange} />
          </Control>
        </Field>
        <Field>
          <Control>
            <Button color="success" type="submit" loading={loading} disabled={!values.subject.trim() || !values.message.trim()}>Submit</Button>
          </Control>
        </Field>
        </form>
      </Section>
    </>
  )
}

export default ContactPage;